/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_GuardrailsInputs */

const en_svchip_guardrails = /** @type {(inputs: Svchip_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardrails`)
};

const ar_svchip_guardrails = /** @type {(inputs: Svchip_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحواجز الأمنية`)
};

const bn_svchip_guardrails = /** @type {(inputs: Svchip_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`গার্ডরেল`)
};

const de_svchip_guardrails = /** @type {(inputs: Svchip_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leitplanken`)
};

const es_svchip_guardrails = /** @type {(inputs: Svchip_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barandillas`)
};

const fr_svchip_guardrails = /** @type {(inputs: Svchip_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garde-corps`)
};

const pt_svchip_guardrails = /** @type {(inputs: Svchip_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarda-corpos`)
};

const zh_svchip_guardrails = /** @type {(inputs: Svchip_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`护栏`)
};

const tr_svchip_guardrails = /** @type {(inputs: Svchip_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korkuluklar`)
};

const ru_svchip_guardrails = /** @type {(inputs: Svchip_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограждения`)
};

const pl_svchip_guardrails = /** @type {(inputs: Svchip_GuardrailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poręcze`)
};

/**
* | output |
* | --- |
* | "Guardrails" |
*
* @param {Svchip_GuardrailsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_guardrails = /** @type {((inputs?: Svchip_GuardrailsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_GuardrailsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_guardrails(inputs)
	if (locale === "bn") return bn_svchip_guardrails(inputs)
	if (locale === "de") return de_svchip_guardrails(inputs)
	if (locale === "es") return es_svchip_guardrails(inputs)
	if (locale === "fr") return fr_svchip_guardrails(inputs)
	if (locale === "pt") return pt_svchip_guardrails(inputs)
	if (locale === "zh") return zh_svchip_guardrails(inputs)
	if (locale === "tr") return tr_svchip_guardrails(inputs)
	if (locale === "ru") return ru_svchip_guardrails(inputs)
	if (locale === "pl") return pl_svchip_guardrails(inputs)
	return en_svchip_guardrails(inputs)
});